import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { adminFormOptions } from "../shared";

export const ContactBlock = withForm({
  ...adminFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>User contact details</FieldLegend>
        <FieldDescription>
          Contact information used for account management, notifications, and
          support.
        </FieldDescription>

        <FieldGroup>
          <Field>
            <form.AppField name="email">
              {(field) => <field.TextField label="Email" />}
            </form.AppField>
          </Field>

          <Field orientation="horizontal">
            <Field>
              <form.AppField name="contact1">
                {(field) => <field.PhoneField label="Primary Phone" />}
              </form.AppField>
            </Field>
            <Field>
              <form.AppField name="contact2">
                {(field) => (
                  <field.PhoneField label="Second Phone (Optional)" />
                )}
              </form.AppField>
            </Field>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
